var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base"},[_c('dropzone',{ref:"dropzone",attrs:{"id":_vm.id,"options":_vm.options},on:{"vdropzone-file-added":_vm.onFileAdded,"vdropzone-removed-file":_vm.onRemovedFile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3367d88e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/product/DropImage.vue
// module id = null
// module chunks = 